import { BlurEvent, DataSourceMode, DropdownSelectionEvent, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutTopMatchProfileDetail } from "./autogen/AutogenLayoutTopMatchProfileDetail";
import { DisplayValue, ModelRow } from "@mcleod/core";
export class TopMatchProfileDetail extends AutogenLayoutTopMatchProfileDetail {

    static SEARCH_TYPES = {
        CARRIER_TERMINAL: "T",
        CARRIER_LANE: "L",
        LOWEST_RATE: "R",
        AVAIL_TRACTOR: "A",
        NUM_MOVES: "N",
        AVG_MARGIN: "M",
        CARRIER_OFFERS: "O",
        LOADBOARDS: "B"
    }

    private NO_DETAIL_SEARCH_TYPES = [
        TopMatchProfileDetail.SEARCH_TYPES.CARRIER_TERMINAL,
        TopMatchProfileDetail.SEARCH_TYPES.CARRIER_LANE,
        TopMatchProfileDetail.SEARCH_TYPES.CARRIER_OFFERS,
    ];

    private TIME_TYPES = [
        TopMatchProfileDetail.SEARCH_TYPES.AVAIL_TRACTOR,
        TopMatchProfileDetail.SEARCH_TYPES.LOADBOARDS
    ];

    private PERCENTAGE_SEARCH_TYPES = [
        TopMatchProfileDetail.SEARCH_TYPES.LOWEST_RATE,
        TopMatchProfileDetail.SEARCH_TYPES.AVG_MARGIN
    ]

    textboxSearchTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.syncSearchType(event.selection.value);
    }

    syncSearchType(searchType: string) {
        const search = this.mainDataSource.mode == DataSourceMode.SEARCH;
        const noDetailSearchType: boolean = this.NO_DETAIL_SEARCH_TYPES.includes(searchType);
        const availTractor: boolean = TopMatchProfileDetail.SEARCH_TYPES.AVAIL_TRACTOR == searchType;
        this.panelAvailTractor.visible = !search && availTractor;
        this.panelComparisons.visible = !search && !noDetailSearchType;
        this.textboxScore.visible = noDetailSearchType;
        if (!search && !noDetailSearchType) {
            this.activeRow.set(this.textboxScore.field, null);
            const scoringCaption = this.getScoringCaption(searchType);
            const column = this.tableDetailGroup.columns[this.tableDetailGroup.getColumnIndex("columnValue")];
            column.headingCell.caption = scoringCaption;
            this.tableDetailGroup.resetColumnSorting();

            const percentageType = this.PERCENTAGE_SEARCH_TYPES.includes(searchType);
            const timeType = this.TIME_TYPES.includes(searchType);
            [this.tableDetailGroup.quickAddRow, ...this.tableDetailGroup.allRows].filter(row => !!row).forEach(tableRow => {
                if (timeType) {
                    this.styleTimeTypeRow(tableRow);
                } else {
                    const textboxComparisonValue = tableRow.findComponentById('textboxComparisonValue') as Textbox;
                    if (textboxComparisonValue) {
                        this.styleDetailGroupScore(textboxComparisonValue, percentageType);
                    }
                }
            });
        }
        if (!search && !availTractor) {
            if (!this.activeRow.isNull('radius')) {
                this.activeRow.set('radius', null);
            }
        }
    }

    getScoringCaption(searchType: string) {
        switch (searchType) {
            case TopMatchProfileDetail.SEARCH_TYPES.LOWEST_RATE:
                return "Average Margin";
            case TopMatchProfileDetail.SEARCH_TYPES.AVG_MARGIN:
                return "Average Margin";
            case TopMatchProfileDetail.SEARCH_TYPES.AVAIL_TRACTOR:
                return "Age";
            case TopMatchProfileDetail.SEARCH_TYPES.NUM_MOVES:
                return "Number of Moves";
            case TopMatchProfileDetail.SEARCH_TYPES.LOADBOARDS:
                return "Posting Age";
            default:
                return "Value";
        }
    }

    tableDetailGroupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxComparisonValue = tableRow.findComponentById('textboxComparisonValue') as Textbox;
        if (textboxComparisonValue) {
            const searchType = this.textboxSearchType.getDataValue();
            const timeType = this.TIME_TYPES.includes(searchType);
            if (timeType) {
                this.styleTimeTypeRow(tableRow);
            } else {
                const percentageType = this.PERCENTAGE_SEARCH_TYPES.includes(searchType);
                this.styleDetailGroupScore(textboxComparisonValue, percentageType);
            }
        }
    }

    styleTimeTypeRow(tableRow: TableRow) {
        const modelRow = tableRow.data as ModelRow;
        const textboxComparisonValue = tableRow.findComponentById('textboxComparisonValue') as Textbox;
        if (textboxComparisonValue) {
            textboxComparisonValue.visible = false;
        }

        const textboxHours = tableRow.findComponentById('textboxHours') as Textbox;
        const textboxMinutes = tableRow.findComponentById('textboxMinutes') as Textbox;

        if (textboxHours && textboxMinutes) {
            textboxHours.visible = true;
            textboxMinutes.visible = true;
            const comparisonValue = modelRow.getNumber('comparison_value', 0);
            const hours = Math.floor(comparisonValue / 60);
            const minutes = comparisonValue % 60;
            textboxHours.text = hours.toString();
            textboxMinutes.text = minutes.toString();
        }
    }



    styleDetailGroupScore(tb: Textbox, percentageType: boolean) {
        tb.format = (percentageType)
            ? "##%"
            : undefined;
        tb.text = DisplayValue.getDisplayValue(tb.getDataValue(), tb.displayType, tb.format);
    }

    textboxHoursOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const hours = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(hours);
            if (!tableRow) return;
            this.syncAgeComparisonValue(tableRow);
        }
    }

    textboxMinutesOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const minutes = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(minutes);
            if (!tableRow) return;
            this.syncAgeComparisonValue(tableRow);
        }
    }

    syncAgeComparisonValue(tableRow: TableRow) {
        const textboxHours = tableRow.findComponentById('textboxHours') as Textbox;
        const textboxMinutes = tableRow.findComponentById('textboxMinutes') as Textbox;

        if (textboxHours && textboxMinutes) {
            const hours = textboxHours.text ? parseInt(textboxHours.text) : 0;
            const minutes = textboxMinutes.text ? parseInt(textboxMinutes.text) : 0;
            const totalMinutes = (hours * 60) + minutes;
            tableRow.data.set('comparison_value', totalMinutes);
            const textboxComparisonValue = tableRow.findComponentById('textboxComparisonValue') as Textbox;
            if (textboxComparisonValue) {
                textboxComparisonValue.text = totalMinutes.toString();
            }
        }
    }
}
